export default __webpack_public_path__ + "static/media/INEFOP_generalDirector.54de4f27.png";